import Vue from 'vue'
import SitewideSearch from '../components/header/SitewideSearch'

import VueAutosuggest from 'vue-autosuggest'
import Features from '../plugins/featuresPlugin'
import LdFeatures from '../plugins/ldFeaturesPlugin'
import installCsrfInterceptor from '../utils/installCsrfInterceptor'
import { installFingerprintAttachments } from '../utils/installFingerprintAttachments'
Vue.use(VueAutosuggest)
Vue.use(Features)
Vue.use(LdFeatures)

// PLT-2324 — register the CSRF attach on the DEFAULT axios instance from here,
// which is the only pack every legacy page emits.
//
// WHY THIS PACK AND NOT `AxiosService.js`. Registering `installCsrfInterceptor(axios)`
// as a side effect of importing `AxiosService` covers a page only if something in that
// page's bundle imports `AxiosService` at all. The `CSRF_MODE=log` window measured what
// that leaves out: `/companies` sent 19 tokenless `PUT /companies/:id.json` with `Origin`
// and `Referer` present — a real browser — because its `company_manager` pack writes
// through the bare `axios` default (`store/companies/actions.js`) and never pulls
// `AxiosService` in. Six sibling packs share that shape (`autocomplete_manager`,
// `call_center_reps`, `discount_manager`, `inspectors_search`, `paysplit_manager`,
// `tag_manager`), and a static guess at webpack's graph would have missed all seven.
//
// WHY REGISTERING HERE REACHES THEM. `_shared/_header_scripts.haml` emits this pack on
// every legacy page — `layouts/application.haml` renders it for the non-vue pages, and
// each `vue`-layout view includes it directly. Webpacker gives every entrypoint on a
// page ONE runtime and one shared vendor chunk, so the `axios` module those packs import
// is the same object this one registers on: one call covers the whole page. Verified
// against the deployed staging bundles — `axios` resolves to a single shared chunk that
// `header_components`, `company_manager` and `availability` all load.
//
// Module scope, not `DOMContentLoaded`: a write can be issued before that fires.
// `installCsrfInterceptor` is idempotent per instance, so `AxiosService`'s own
// registration stays and simply becomes a no-op second call.
installCsrfInterceptor()

// Device-fingerprint coverage (PLT-2049). This pack is emitted from
// `_shared/_header_scripts.haml` on every page — both its `non_vue_page` branch
// and its `append_javascript_pack_tag` branch — which is why the priming step
// and the global ajax hooks live here rather than in a pack of their own.
//
// `$` is the ProvidePlugin-injected, *pack-bundled* jQuery — a different object
// from the sprockets `window.jQuery` the 58 legacy files use, which is exactly
// the trap the installer guards against. It is handed in so both get hooked.
// Referenced bare on purpose: the ProvidePlugin rewrites a free `$` into the
// module require, but leaves a `typeof $` guard alone — which would hand the
// installer a null and quietly skip the pack-side registration.
installFingerprintAttachments({ packJquery: $ })

const loadComponents = () => {
  // Make sure Vue is loaded
  if (typeof Vue === 'undefined') {
    setTimeout(loadComponents, 500)
    return
  }

  const loggedInDataEl = document.getElementsByClassName('js-logged-in-data')

  if (loggedInDataEl.length > 0) {
    const isCompanyAdmin =
      loggedInDataEl[0].dataset['isCompanyAdmin'] !== undefined
    const profileType = loggedInDataEl[0].dataset.profileType
    const isValidProfile =
      profileType === 'Manager' || profileType === 'Inspector'

    if (isCompanyAdmin || isValidProfile) {
      window.sitewideSearchApp = new Vue({
        // eslint-disable-line no-unused-vars
        el: '#js-sitewide-search',
        render: (h) => h(SitewideSearch),
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  loadComponents()
})
